import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 60 * 5, // 5분간 캐시 유지 (업비트 데이터는 WebSocket으로 실시간 업데이트)
      gcTime: 1000 * 60 * 10, // 10분간 메모리에 보관
      refetchOnWindowFocus: false, // 윈도우 포커스 시 재조회 방지
      refetchOnMount: false, // 컴포넌트 재마운트 시 재조회 방지
    },
  },
});
